module.exports = __webpack_public_path__ + "static/media/bomb.5efe757e.svg";